export default __webpack_public_path__ + "static/media/sidebar-bg.609aa536.webp";